import React, { Component } from "react";
import { Link } from "react-router-dom";
import { MatchScorecard, returnDashIfNull } from "./Match";

import {
  VideoCard,
  Scorecard,
  NewsBulletins,
  NewsCard,
  FullWidthCard,
  space2hyphen,
  MatchScorecardSection,
} from "./HelperFunctions";
import { Helmet } from "react-helmet";
import { canonicalLink } from "./HelperFunctions";

class HomeSeriesCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      videos: [],
      newsBulletins: [],
      matches: [],
      match: [],
      articles: [],
      seriesObj: {},
      isMatchLive: false,
      isMounted: false,
      isUpdated: false,
    };
    this.setSeries = this.setSeries.bind(this);
  }

  handleUrlString = (str) => {
    let expr = str.split("/");
    return expr[5];
  };

  setSeries(isUpdated) {
    let videos = [],
      newsBulletins = [],
      articles = [],
      matches = [],
      match = [],
      isMatchLive = false,
      seriesObj = this.props.data.series_obj,
      data = this.props.data.data.slice();

    return data.map((obj, i) => {
      switch (obj.type) {
        case "videos":
          // videos = val.data.slice();
          return obj.data.length ? (
            <div key={"ser-v-" + i} className="py-2 mb-3 border-bottom">
              {" "}
              {obj.data.map((val, j) => {
                if (j === 0) {
                  return (
                    <div key={"outersv-" + j} className="pt-2">
                      <FullWidthCard
                        type="video"
                        seriesId={seriesObj.id}
                        seriesTitle={seriesObj.short_name}
                        subType="video"
                        data={val}
                      />
                    </div>
                  );
                } else {
                  return (
                    <div key={"outersv-" + j} className="py-2">
                      <VideoCard
                        key={"sv-" + j}
                        image={val.thumb}
                        id={val.id}
                        seriesId={seriesObj.id}
                        seriesTitle={seriesObj.short_name}
                        seriesPropsId={this.props.seriesId}
                        matchTitle={val.match_obj.title}
                        title={val.title}
                        description={val.match_desc}
                        showDescription={true}
                      />
                    </div>
                  );
                }
              })}
            </div>
          ) : (
            <div key={"ser-v-" + i} />
          );
        case "news":
          // newsBulletins = val.data.slice();
          return obj.data.map((val, j) => (
            <div key={"nc-" + j} className="pt-4 px-3">
              <NewsCard
                image={val.image}
                id={val.id}
                title={val.title}
                date={val.published}
              />
            </div>
          ));
        case "matches":
          // isMatchLive = obj.data.findIndex(obj2 => obj2.match_state.toLowerCase() === 'live') > -1;
          return obj.data.map((val, j) => (
            <Scorecard key={"ms-hs-" + j} data={val} showMatchReportButton />
          ));
        case "match_object":
          // match.push(val.data);
          // match = val.data.slice();
          // isMatchLive = obj.data.findIndex(obj2 => obj2.match_state.toLowerCase() === 'live') > -1;
          return <Scorecard key={"ms-hs-" + i} data={obj.data} />;
        // return obj.data.map( (val, j) =>
        //     <Scorecard key={"ms-hs-"+j} data={val} />
        // )
        case "article":
          // articles = val.data.slice();
          return obj.data.map((val, j) => (
            <div key={"nc-" + j} className="pt-4 px-3">
              <NewsCard
                image={val.image}
                id={val.id}
                title={val.title}
                date={val.created_at}
              />
            </div>
          ));
        case "articles":
          // articles = val.data.slice();
          return obj.data.map((val, j) => (
            <div key={"nc-" + j} className="pt-4 px-3">
              <NewsCard
                image={val.image}
                id={val.id}
                title={val.title}
                date={val.created_at}
              />
            </div>
          ));
        default:
          console.log("Unknown type", obj.type);
      }
    });

    // const seriesObj = Object.assign({}, this.props.data.series_obj);

    // this.setState({ videos: videos, newsBulletins: newsBulletins, matches: matches, articles: articles,
    //  isMatchLive: isMatchLive, seriesObj: seriesObj, match: match, isMounted: true, isUpdated: isUpdated });
  }

  // componentDidMount() {
  //     if (!this.state.isMounted) {
  //         this.setSeries(false);
  //     };
  // }

  // componentDidUpdate() {
  //     if (this.state.isMounted && !this.state.isUpdated && this.state.seriesObj.hasOwnProperty('id') && (this.state.seriesObj.id !== this.props.seriesId)) {
  //         this.setSeries(true);
  //     };
  // }

  render() {
    return this.props.data.series_obj ? (
      <div className="card mb-2">
        <Helmet>
          <link rel="canonical" href={canonicalLink()} />
        </Helmet>
        <div className="series-card-heading mb-2">
          <Link
            to={
              "/series/" +
              this.props.data.series_obj.id +
              "/" +
              space2hyphen(this.props.data.series_obj.short_name)
            }
            className="border-bottom d-block p-3 w-100 text-left"
          >
            <h2 className="font-weight-bold m-f-14 mb-0">
              {this.props.data.title}
            </h2>
          </Link>
        </div>
        <div className="p-3">
          {
            this.setSeries()
          }
        </div>
        
      </div>
    ) : (
      ""
    );
  }
}

export default HomeSeriesCard;
